import { getLocalStorage } from "@/common/cookie.js";
import { get, post } from "@/common/request.js";

// 取得結帳資訊
export function getCashier(
  coupon = "",
  payment = 0,
  shipping = 0,
  shopcart,
  zip_code = ""
) {
  let data = {
    CouponCode: coupon, //優惠代碼
    PaymentID: payment, //付款方式
    ShippingID: shipping, //物流方式
    ShoppingCart: [], //購物車內容
    ZipCode: zip_code, //郵遞區號
  };
  // 依照傳入的購物車資訊提取API需要的資料放入ShoppingCart中
  shopcart.forEach((item) => {
    for (let i = 0; i < item.amount; i++) {
      if (item.is_custom == "Y") {
        data.ShoppingCart.push({
          GoodsID: item.goodsID, //商品ID
          CustomSpecID: item.active_option.join(), //規格ID組合
          ShoppingCartID: item.shopcart_id[i] ?? "", //購物車ID
        });
      } else {
        data.ShoppingCart.push({
          GoodsID: item.goodsID, //商品ID
          ColorID: item.active_option[0], //選項一ID
          SizeID: item.active_option[1], //選項二ID
          ShoppingCartID: item.shopcart_id[i] ?? "", //購物車ID
        });
      }
    }
  });

  if (getLocalStorage("account_token")) {
    // 會員API
    return post("member/cashier", data);
  } else {
    // 無會員API
    return post("nonMember/cashier", data);
  }
}

// 送出結帳
export function SendCheckout(user_data, shopcart, require_shop_info) {
  // 篩選郵遞區號

  let data = {
    BuyerName: user_data.buyer_name, //購買者姓名
    BuyerPhone: user_data.buyer_phone, //購買者電話
    ReceiverName: user_data.consignee_name, //收件人姓名
    ReceiverPhone: user_data.consignee_phone, //收件人電話
    ReceiverEmail: user_data.consignee_email, //收件人Email
    ReceiverAddressCode: user_data.zip_code || 0, //收件郵遞區號
    ReceiverAddress: user_data.consignee_address, //收件地址
    ReceiverMemo: user_data.comment, //訂單備註
    DeliveryTime: user_data.delivery_time, //指定送達時間
    CouponCode: user_data.coupon, //優惠代碼
    PaymentID: user_data.pay_way, //付款方式
    ShippingID: user_data.ship_way, //物流方式
    ReceiverStoreNo: "", //超商取貨ID
    ReceiverStoreInfo: "", //超商取貨門市資訊
    OrderMemo: "", //分潤標籤
    ShoppingCart: [], //購物車
  };

  // 如果有填寫帳號末五碼
  if (user_data.bank_account) {
    data.ReceiverMemo != "" ? (data.ReceiverMemo += "\n") : "";
    data.ReceiverMemo += "匯款帳號末五碼：" + user_data.bank_account;
  }

  // 如果是超商取貨
  if (require_shop_info) {
    data.ReceiverStoreNo = user_data.shop_id;
    data.ReceiverStoreInfo = user_data.shop_name;
  }

  if (shopcart.filter((item) => item.order_memo != "").length > 0) {
    // 撈出全部的eventMemo，並找出重複最多次的放入OrderMemo
    let eventMemoList = shopcart
      .map((item) => item.order_memo)
      .filter((item) => item != "");
    let eventMemo = eventMemoList
      .sort(
        (a, b) =>
          eventMemoList.filter((v) => v === a).length -
          eventMemoList.filter((v) => v === b).length
      )
      .pop();
    data.OrderMemo = eventMemo;
  }

  // 依照傳入的購物車資訊提取API需要的資料放入ShoppingCart中
  shopcart.forEach((item) => {
    for (let i = 0; i < item.amount; i++) {
      if (item.is_custom == "Y") {
        data.ShoppingCart.push({
          GoodsID: item.goodsID,
          CustomSpecID: item.active_option.join(),
        });
      } else {
        data.ShoppingCart.push({
          GoodsID: item.goodsID,
          ColorID: item.active_option[0],
          SizeID: item.active_option[1],
        });
      }
    }
  });

  if (getLocalStorage("account_token")) {
    // 會員API
    return post("member/checkout", data);
  } else {
    // 無會員API
    return post("nonMember/checkout", data);
  }
}

// 取得超商取貨門市資料
export function GetStoreMap(shippingData, event_url) {
  let gateway = "";
  if (shippingData.ShippingType.indexOf("NEWEB") != -1) {
    gateway = "NewebPay";
  } else {
    gateway = "ECLogistics";
  }

  event_url = encodeURI(event_url);
  if (getLocalStorage("member_token")) {
    //有會員API
    return get(
      `member/C2CMap?Gateway=${gateway}&ShippingType=${shippingData.ShippingType}&ReturnURL=${event_url}`
    );
  } else {
    //無會員API
    return get(
      `nonMember/C2CMap?Gateway=${gateway}&ShippingType=${shippingData.ShippingType}&ReturnURL=${event_url}`
    );
  }
}

// 取得7-11門市地圖
export function Get711Map(event_url = "") {
  if (getLocalStorage("member_token")) {
    //有會員API
    return event_url != ""
      ? get("member/711Map?EventUrl=" + event_url)
      : get("member/711Map");
  } else {
    //無會員API
    return event_url != ""
      ? get("nonMember/711Map?EventUrl=" + event_url)
      : get("nonMember/711Map");
  }
}

// 取得全家門市地圖
export function GetFamilyMap(event_url = "") {
  if (getLocalStorage("member_token")) {
    //有會員API
    return event_url != ""
      ? get("member/FamilyMap?EventUrl=" + event_url)
      : get("member/FamilyMap");
  } else {
    //無會員API
    return event_url != ""
      ? get("nonMember/FamilyMap?EventUrl=" + event_url)
      : get("nonMember/FamilyMap");
  }
}

// 非會員查詢訂單
export function GetOrder(trade_id, phone) {
  let data = {
    TradeID: trade_id, //訂單編號
    BuyerPhone: phone, //訂購人電話
  };
  return post("nonMember/trade", data);
}

// 會員加入購物車
export function AddShopCart(product, amount) {
  let shopcart = [];
  // 因為加入購物車API一次只能傳入一個商品，所以要依照使用者選擇的商品數量，數量有幾個API就要呼叫幾次
  for (let i = 0; i < amount; i++) {
    shopcart.push(product);
  }

  return post("member/shoppingCart", { ShopcartData: shopcart });
}

// 會員移除購物車商品
export function RemoveShopCart(remove_list) {
  return post("member/shoppingCart/del", { IDList: remove_list });
}

// 取得會員購物車資料
export function GetShopCart() {
  return get("member/shoppingCart");
}

// get auto coupon
export function GetCoupon() {
  if (getLocalStorage("account_token")) {
    return get("member/coupon");
  } else {
    return get("nonMember/coupon");
  }
}
